

class Util {
  // 车辆型号新增车辆状态
  Status() {
    var option = [
      {
        status: '00',
        name: '启用'
      },
      {
        status: '10',
        name: '禁用'
      }
    ]
    return option
  }
  carStatus() {
    var option = [
      {
        status: '00',
        name: '启用'
      },
      {
        status: '10',
        name: '禁用'
      }
    ]
    return option
  }
  // 新增、修改网点状态
  networkStatus() {
    var option = [
      {
        status: '0',
        name: '启用'
      },
      {
        status: '1',
        name: '禁用'
      }
    ]
    return option
  }
  // 网点模式
  networkModel() {
    var option = [
      {
        name: '直营',
        status: '10'
      },
      {
        name: '合作',
        status: '20'
      }
    ]
    return option
  }
  // 用户实名状态
  driverStatus() {
    var option = [
      {
        status: '00',
        name: '未认证'
      },
      {
        status: '30',
        name: '待认证'
      },
      {
        status: '10',
        name: '认证通过'
      },
      {
        status: '20',
        name: '认证未通过'
      }
    ]
    return option
  }
  // 用户驾照状态
  realName() {
    var option = [
      {
        status: '10',
        name: '认证通过'
      },
      {
        status: '20',
        name: '认证未通过'
      }
    ]
    return option
  }
  // 车辆信息用车状态
  userCarStatus() {
    var option = [
      {
        status: '00',
        name: '闲置中'
      },
      {
        status: '10',
        name: '已预约'
      },
      {
        status: '20',
        name: '使用中'
      }
    ]
    return option
  }
  // 订单页面 支付状态
  payFlag() {
    var option = [
      {
        status: '10',
        name: '已支付'
      },
      {
        status: '20',
        name: '待支付'
      }
    ]
    return option
  }
  // 订单页面 订单状态
  orderStatus() {
    var option = [
      {
        status: '10',
        name: '已锁定'
      },
      {
        status: '20',
        name: '用车中'
      },
      {
        status: '30',
        name: '已还车'
      },
      {
        status: '40',
        name: '作废'
      }
    ]
    return option
  }
  // 时间戳转化时间
  dataTime(time) {
    if (!time) {
      return
    }
    var date = new Date(time) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    var h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m =
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':'
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
  }
  // 树形结构数据
  jsonTree(data, config) {
    // eslint-disable-next-line one-var
    var id = config.id || 'id'
    var pid = config.pid || 'pid'
    var children = config.children || 'children'
    var idMap = []
    var jsonTree = []
    data.forEach(function(v) {
      idMap[v[id]] = v
    })
    data.forEach(function(v) {
      var parent = idMap[v[pid]]
      delete v.parent
      if (parent) {
        !parent[children] && (parent[children] = [])
        parent[children].push(v)
      } else {
        jsonTree.push(v)
      }
    })
    return jsonTree
  }
  removeValue(arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val) {
        arr.splice(i, 1)
      }
    }
  }
  getDiff(arr1,arr2){
    return arr1.filter(key =>!arr2.includes(key));
  }
}

export default new Util()



// WEBPACK FOOTER //
// ./src/common/js/util.js